var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcSocialLinks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11.0778C27.5 13.0109 26.7577 14.8676 25.4322 16.2411C22.3811 19.4038 19.4217 22.7016 16.2566 25.7496C15.5311 26.4381 14.3802 26.413 13.686 25.6934L4.5672 16.2411C1.81093 13.384 1.81093 8.77154 4.5672 5.91446C7.35055 3.02931 11.8849 3.02931 14.6682 5.91446L14.9997 6.25803L15.331 5.91466C16.6655 4.53063 18.483 3.75 20.3816 3.75C22.2802 3.75 24.0976 4.53055 25.4322 5.91446C26.7579 7.28806 27.5 9.14471 27.5 11.0778Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialLinks);
export default __webpack_public_path__ + "static/media/ic-social-links.88215cf40befd9f5aca483d50b4150f6.svg";
export { ForwardRef as ReactComponent };